import { render } from "./BaseGeoCell.vue?vue&type=template&id=61b0f6d3"
import script from "./BaseGeoCell.vue?vue&type=script&lang=js"
export * from "./BaseGeoCell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__